import { CLIENT_REPORTING_STOCKS } from './ClientReportingStocks';
import { CLIENT_REPORTING_BENCHMARK_SYMBOLS } from './clientReportingBenchmarkConfig';
import { WORLD_MARKET_SYMBOLS } from './clientReportingWorldMarketsConfig';

export { WORLD_MARKET_SYMBOLS };

export function allSidebarQuoteSymbols() {
  return Array.from(new Set([
    ...CLIENT_REPORTING_STOCKS.map((stock) => stock.symbol),
    ...WORLD_MARKET_SYMBOLS,
    ...CLIENT_REPORTING_BENCHMARK_SYMBOLS,
  ]));
}

export function quotesBySymbolFromResponse(markets) {
  const next = {};
  (markets || []).forEach((market) => {
    const key = String(market.id || market.symbol || '').trim().toUpperCase();
    if (key) next[key] = market;
  });
  return next;
}
